/** Extensions that mark a bare "name.ext" as a file name (e.g. in a shared folder), not a website. */
const FILE_EXT = /\.(svg|ai|eps|pdf|png|jpe?g|gif|webp|heic|tiff?|psd|indd|zip|mp4|mov|otf|ttf|woff2?|docx?|pptx?|xlsx?|key)$/i

/** A URL worth opening: anything with a dot that isn't obviously not a web address. Adds https:// when missing. */
export function openableUrl(value: string): string | null {
  const v = value.trim()
  if (!v || /\s/.test(v) || !v.includes('.')) return null
  if (!/^https?:\/\//i.test(v) && !v.includes('/') && FILE_EXT.test(v)) return null
  const withScheme = /^https?:\/\//i.test(v) ? v : `https://${v}`
  const host = withScheme.replace(/^https?:\/\//i, '').split(/[/?#]/)[0]!
  return /^[a-z0-9-]+(\.[a-z0-9-]+)+(:\d+)?$/i.test(host) ? withScheme : null
}

/** How a URL reads in a preview line: no scheme, no www, no trailing slash. */
export function displayUrl(href: string): string {
  return href.replace(/^https?:\/\//i, '').replace(/^www\./i, '').replace(/\/$/, '')
}
